/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'minus': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M8.778 5.19A13 13 0 0116 3a13.015 13.015 0 0113 13A13 13 0 118.778 5.19zm1.515 11.517A1 1 0 0011 17h10a1 1 0 000-2H11a1 1 0 00-.707 1.707z" _fill="#0B2C62"/><path pid="1" fill-rule="evenodd" clip-rule="evenodd" d="M21.992 16a1 1 0 01-1 1H10.99a1 1 0 010-2h10.002a1 1 0 011 1z" _fill="#fff"/>'
  }
})
